import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteReason(uuid: string): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/reason/${uuid}`)
}
